'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlUnreserved = require('./validateUrlUnreserved');

var _validateUrlUnreserved2 = _interopRequireDefault(_validateUrlUnreserved);

var _validateUrlPctEncoded = require('./validateUrlPctEncoded');

var _validateUrlPctEncoded2 = _interopRequireDefault(_validateUrlPctEncoded);

var _validateUrlSubDelims = require('./validateUrlSubDelims');

var _validateUrlSubDelims2 = _interopRequireDefault(_validateUrlSubDelims);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// These URL validation pattern strings are based on the ABNF from RFC 3986
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validateUrlPchar = (0, _regexSupplant2.default)('(?:' + '#{validateUrlUnreserved}|' + '#{validateUrlPctEncoded}|' + '#{validateUrlSubDelims}|' + '[:|@]' + ')', { validateUrlUnreserved: _validateUrlUnreserved2.default, validateUrlPctEncoded: _validateUrlPctEncoded2.default, validateUrlSubDelims: _validateUrlSubDelims2.default }, 'i');

exports.default = validateUrlPchar;
module.exports = exports['default'];